import type { IconSvgObject } from './types';

const PackageDimensions02Icon: IconSvgObject = [
  ["path", { d: "M21 9L14 6L7 9L14 12L21 9Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 22L21 19V9M14 22L7 19V9M14 22V12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17.5 7.5L10.5 10.5V13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 3H21M7 3V2M7 3V4M21 3V2M21 3V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M4 7L4 21M4 7L5 7M4 7L3 7M4 21H5M4 21H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default PackageDimensions02Icon;
